const ERRORS = {
  noDealerLocator: 'Dealer Locator Markup was not found',
  missingParameter: 'Missing Parameter: ',
  noVehicleData: 'Missing Vehicle Data: ',
  endpointFailed: 'Endpoint Failed: ',
  noEndpoint: 'No endpoint url was provided on CMS',
  noTokenProvided: 'Token Value was not provided',
  badRequest: 'Bad request sent: ',
  vehicleData: {
    noVehicleDealerSelected: 'A Vehicle and Dealer should be selected',
    noInteriorColor: 'No interior color match was found. Missing fabrics?',
    noExteriorColor: 'No exterior color match was found',
    noModelsNode: 'Modelid does not exist on [models] node or missing [models] node',
  },
};

export default ERRORS;
